import A from './types';
import cloneDeep from 'lodash/cloneDeep';
import resourceId from '~/misc/resourceId';
import {fallbackToArray, ensureQueryDefaults} from '~/misc/search';
import safeJSONParse from '~/misc/safeJSONParse';
import getStorageValue from '~/misc/getStorageValue';
import {inputValuesAll} from '~/misc/equipment';

const getResourceIdentity = (queryCompleted) => resourceId('alertList', {
  query: queryCompleted,
});

const init = () => {
  return {
    identity: getResourceIdentity(null),
    query: ensureQueryDefaults({
      equipment: fallbackToArray(safeJSONParse(getStorageValue('equipment'))).filter(i => inputValuesAll.includes(i)),
      loadSize: 'full',
    }),
    mathesLoadLoading: true,
    equipment: 'flatbed',
    pushAvailable: true,
    alertList: [],
    initForm: {},
    isSelectAll : false,
    loading: false,
  };
};

const addSelectStatusToList = (oldList, data) => {
  let newList = data.list;
  let processList = newList.map(item => {
    item.selected = false;
    return item;
  });
  let selectedList = [];
  oldList && oldList.forEach(item => {
    if(item.selected){
      selectedList.push(item.id);
    }
  })
  if (!selectedList.length || data.noneSelected) {
    return processList;
  }
  selectedList.forEach(item => {
    processList.map(li => li.id === item && (li.selected = true));
  });
  return processList;
}

const reducer = (state, action, fullState) => {
  switch (action.type) {
    case A.ALERT: {
      return {};
    }
    case A.LIST_CHANGE_SELECTED: {
      return {
        ...state,
        list: state.list.map(item => {
          if(item.id === action.payload.id){
            item.selected = !item.selected;
          }
          return item;
        }),
        isSelectAll: false
      };
    }
    case A.LIST_CHANGE_SELECTED_ALL: {
      if(!state.isSelectAll) {
        return {
          ...state,
          list: state.list.map(item => {
            item.selected = true;
            return item;
          }),
          isSelectAll: true
        }
      }
      return {
        ...state,
        list: state.list.map(item => {
          item.selected = false;
          return item;
        }),
        isSelectAll: false
      }
    }
    case A.SET_ALL_ALERTS_START: {
      return {
        ...state,
        loading: true
      };
    }
    case A.SET_ALL_ALERTS: {
      return {
        ...state,
        list: addSelectStatusToList(state.list, action.payload),
        equipment: action.payload.equipment,
        pushAvailable: action.payload.pushAvailable,
        loading: false,
        isSelectAll: false,
      };
    }
    case A.DELETE_ALERT: {
      return {
        ...state,
        list: state.list.map(item => item.id !== action.payload.id),
      };
    }
    case A.INIT_ALERT_FORM: {
      const initForm = action.payload.result;
      return {
        ...state,
        initForm
      }
    }
    case A.ALERT_LOADS_LIST_LOADING: {
      return {
        ...state,
        mathesLoadLoading: true
      }
    }
    case A.ALERT_LOADS_LIST: {
      const LoadsList = action.payload.list;
      LoadsList.shipments = LoadsList.shipments.map(item => ({
        ...item,
        identity: resourceId('alertList', {
          id: item.id,
        }, state.identity),
        parentIdentity: state.identity
      }))
      return {
        ...state,
        LoadsList,
        mathesLoadLoading: false
      }
    }
  }
  return null;
}

export default {reducer, init};



// WEBPACK FOOTER //
// ./src/modules/alert/reducer.js